import { useEffect, useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import EmailPreviewCard from '../../components/Emails/EmailPreviewCard';
import ErrorMessage from '../../components/ErrorMessage';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const ProfilesDetailsEmailsPage = ({ profile }) => {
  const [emails, setEmails] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();
  const { accountId, domainId } = useParams();

  const fetchURL = `/api/admin/accounts/${accountId}/domains/${domainId}/profiles/emails`;

  useEffect(() => {
    fetch(fetchURL, {
      method: 'POST',
      body: JSON.stringify({ profileEmail: profile.email }),
    })
      .then(async ({ emails }) => {
        setEmails(emails);
      })
      .catch((error) => setError(error));
  }, [fetch, fetchURL, profile.email]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!emails) {
    return <Spinner />;
  }

  const emailCards = emails.map((email) => <EmailPreviewCard key={email.id} email={email} />);

  return <>{emails.length > 0 ? emailCards : <Box ta="center">No data was found.</Box>}</>;
};

export default ProfilesDetailsEmailsPage;
